import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStore } from '@app-auth/data-access/auth.store';
import { BiometricStore } from '@app-auth/data-access/biometric.store';


export const CommonGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const biometricStore = inject(BiometricStore);
  const router = inject(Router);

  // Logged in → never stay on login/onboarding, go straight home.
  if (authStore.isLoggedIn()) {
    router.navigate(['/home']).then();
    return false;
  }

  // Logged out + biometric enrolled → force the biometric login screen, except when already
  // heading to a /login route (so the biometric and password screens stay reachable).
  if (biometricStore.enabled() && !state.url.includes('login')) {
    router.navigate(['/login/biometrics']).then();
    return false;
  }

  return true;
};
